import { render, staticRenderFns } from "./campo-text-area-editavel.vue?vue&type=template&id=0a782e7d"
import script from "./campo-text-area-editavel.vue?vue&type=script&lang=js"
export * from "./campo-text-area-editavel.vue?vue&type=script&lang=js"
import style0 from "./campo-text-area-editavel.vue?vue&type=style&index=0&id=0a782e7d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports